/* ==========================================================================
   SearcherFli > Client > Passenger > Adults
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const { addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const Counter = require('@bluekiri/alexandria-contrib-components/components/counter-rxjs/client/js');
/* eslint-disable */
const CounterActions = require('@bluekiri/alexandria-contrib-components/components/counter-rxjs/client/js/store/actions');
/* eslint-enable */
const CounterTemplate = require('@bluekiri/alexandria-contrib-components/components/counter-rxjs/template');

const { ADULTS } = require('../../constants');

const configuration = require('../../../config');

/* Render counter */
const renderCounter = (adults, literals, context) => {
    /* Data */
    const { description = '', max = 8, min = 0, value = 0 } = adults;
    const { adultsLabel } = literals;

    return CounterTemplate(
        addData(
            {
                label: adultsLabel,
                description,
                min,
                max,
                value
            },
            {
                type: configuration().type[ADULTS]
            }
        ),
        context
    );
};

/* Create */
function createAdults(instance, adults) {
    if (!adults) {
        return html('');
    }

    /* Data */
    const { literals, context } = instance.config;

    /* Template */
    return renderCounter(adults, literals, context);
}

/* Init */
function initAdults(instance, adults) {
    if (!adults) {
        return;
    }

    const panel = instance;

    /* Selector */
    const { selector } = instance;

    /* Hooks */
    panel.hooks = {
        ...instance.hooks,
        [ADULTS]: instance.element.querySelector(`[data-${ADULTS}]`)
    };

    /* Reference */
    panel[ADULTS] = {
        counter: Counter(`${selector} [data-component='CounterRxjs'][data-type='${configuration().type[ADULTS]}']`),
        options: []
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        addAdult: instance[ADULTS].counter.store.subscribe((state, action) => {
            if (action.type !== CounterActions.types.INCREMENT) return;

            const { value } = state.counter;

            instance.actions.changePassengers({ adults: value });
        }),
        removeAdult: instance[ADULTS].counter.store.subscribe((state, action) => {
            if (action.type !== CounterActions.types.DECREMENT) return;

            const { value } = state.counter;

            instance.actions.changePassengers({ adults: value });
        })
    };
}

/* Destroy */
function destroyAdults(instance, adults) {
    if (!adults) {
        return;
    }

    const panel = instance;

    /* Hooks */
    delete panel.hooks[ADULTS];

    /* Reference */
    instance[ADULTS].counter.actions.destroy();
    delete panel[ADULTS].counter;

    /* Reactions */
    instance.reactions.addAdult.unsubscribe();
    delete panel.reactions.addAdult;

    instance.reactions.removeAdult.unsubscribe();
    delete panel.reactions.removeAdult;
}

/* Exports */
module.exports = {
    createAdults,
    initAdults,
    destroyAdults
};
